import { Icon, IconClose, IconMagnifier } from "@flixbus/honeycomb-icons-react";
import { Button, Input } from "@flixbus/honeycomb-react";
import { Breakpoint, ResponsiveRenderer } from "@flixbus-phx/marketplace-common";
import * as React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import searchArticles from "../../helpers/searchArticles/searchArticles";
import { Article } from "../../types";
import * as css from "./SearchInput.scss";

export type SearchInputProps = {
  searchValue: string;
  onSearchValueChanged: (value: string) => void;
  articles: Array<Article>;
  onSearchResultChanged: (result: Array<Article> | undefined) => void;
};

const SearchInput: React.FC<SearchInputProps> = ({
  searchValue,
  onSearchValueChanged,
  articles,
  onSearchResultChanged,
}) => {
  const { formatMessage } = useIntl();
  const handleSearch = () => onSearchResultChanged(searchArticles(searchValue, articles));

  return (
    <div className={css.searchWrapper}>
      <Input
        aria-label="Search input"
        id="search"
        value={searchValue}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => onSearchValueChanged(event.target.value)}
        onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
          if (event.key === "Enter" && searchValue) {
            handleSearch();
          }
        }}
        iconRight={
          searchValue ? (
            <Button
              aria-label="Clear search input"
              onClick={() => {
                onSearchValueChanged("");
                onSearchResultChanged(undefined);
              }}
            >
              <Icon appearance="primary" InlineIcon={IconClose} extraClasses={css.clearIcon} />
            </Button>
          ) : undefined
        }
        placeholder={formatMessage({ id: "faq.search.placeholder" })}
        extraClasses={css.input}
      />

      <ResponsiveRenderer hidden={[Breakpoint.XXS, Breakpoint.XS, Breakpoint.SM]}>
        <Button data-id="search-button" appearance="primary" disabled={!searchValue} onClick={handleSearch}>
          <FormattedMessage id="general.search" />
        </Button>
      </ResponsiveRenderer>
      <ResponsiveRenderer hidden={[Breakpoint.MD, Breakpoint.LG, Breakpoint.XL]}>
        <Button
          data-id="search-button"
          display="square"
          appearance="primary"
          disabled={!searchValue}
          onClick={handleSearch}
        >
          <Icon InlineIcon={IconMagnifier} />
        </Button>
      </ResponsiveRenderer>
    </div>
  );
};

export default SearchInput;
